import { render } from "./BsModal.vue?vue&type=template&id=4db509ba"
import script from "./BsModal.vue?vue&type=script&lang=js"
export * from "./BsModal.vue?vue&type=script&lang=js"
script.render = render

export default script